const middleware = {}

middleware['breadcrumbs'] = require('../middleware/breadcrumbs.js')
middleware['breadcrumbs'] = middleware['breadcrumbs'].default || middleware['breadcrumbs']

middleware['filters'] = require('../middleware/filters.js')
middleware['filters'] = middleware['filters'].default || middleware['filters']

export default middleware
